import Vue from 'vue';
import Vuex from 'vuex';

import i18n from '@/lib/i18n';
import Api from '@/lib/Api';
import createRandomId from '@/lib/createRandomId';

import bottomSheet from './bottomSheet';
import dialog from './dialog';
import statistics from './statistics';
import widget from './widget';
import productCategories from './productCategories';
import reviewOptionTypes from './reviewOptionTypes';
import evaluationTypeStatistics from './evaluationTypeStatistics';
import productOptionTypes from './productOptionTypes';
import window from './window';
import googleTranslator from './googleTranslator';
import translationManager from './translationManager';
import browserTranslationManager from './browserTranslationManager';
import iframeTranslationManager from './iframeTranslationManager';
import crmLandingPage from './crmLandingPage';
import productScoreSummary from './productScoreSummary';
import productMediaReviewSummary from './productMediaReviewSummary';
import productMediaReviewCollage from './productMediaReviewCollage';
import productReviewThumbnails from './productReviewThumbnails';
import review from './review';
import like from './like';
import comment from './comment';
import product from './product';
import reviewSettings from './reviewSettings';
import session from './session';
import translation from './translation';
import reviewTagTypes from './reviewTagTypes';
import category from './category';
import facebook from './facebook';
import userProperties from './userProperties';
import form from './form';
import sizeRecommendation from './sizeRecommendation';

import menu from './design/menu';

import mutations from './mutations';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    env: null,
    preview: false,
    brandCode: 'cafe23.com',
    title: i18n.t('app.default_title'),
    productCode: null,
    api: null,
    categoryCode: null,
    categoryId: null,
    scores: null,
    sort: null,
    query: null,
    withVideo: null,
    unlinkable: null,
    reviewOptions: {},
    productOptions: {},
    cohortItemId: null,
    expiresSince: null,
    expiresUntil: null,
    widgetEnv: null,
    parentWidgetType: null,
    pageViewId: createRandomId() // 데이터팀 사용, 퍼널 이벤트를 상품 페이지 로드 1회로 묶는 키. 위젯 iframe 로드마다 새로 만든다.
  },
  mutations,
  actions: {
    initApi({ commit }, { brandCode, sessionParams, preview, dummy, locale }) {
      commit(
        'SET_API',
        new Api(brandCode, sessionParams, preview, dummy, locale)
      );
    }
  },
  getters,
  modules: {
    bottomSheet,
    dialog,
    statistics,
    widget,
    productCategories,
    reviewOptionTypes,
    evaluationTypeStatistics,
    productOptionTypes,
    window,
    googleTranslator,
    translationManager,
    browserTranslationManager,
    iframeTranslationManager,
    crmLandingPage,
    productScoreSummary,
    productMediaReviewSummary,
    productMediaReviewCollage,
    productReviewThumbnails,
    review,
    like,
    comment,
    product,
    reviewSettings,
    session,
    menu,
    reviewTagTypes,
    translation,
    category,
    facebook,
    userProperties,
    form,
    sizeRecommendation
  }
});
